import classNames from "classnames/bind";
import type { ButtonProps } from "common/blocks/Button";
import Button from "common/blocks/Button";
import { ResolvedMegaMenuCtaButton } from "resolvers/data/header/megaMenuResolver";
import styles from "../HeaderMegaMenu.module.scss";

const cx = classNames.bind(styles);

export type HeaderMegaMenuCtaButtonProps = {
    sectionContent: {
        body: ResolvedMegaMenuCtaButton[];
        position: string;
    };
};

const ButtonPriorityMap = {
    primary: "accent" as ButtonProps["theme"],
    secondary: "primary" as ButtonProps["theme"],
    tertiary: "tertiary" as ButtonProps["theme"],
};

const HeaderMegaMenuCtaButtons: React.FC<HeaderMegaMenuCtaButtonProps> = ({ sectionContent }) => {
    if (!sectionContent.body?.length) return null;

    return (
        <div className={cx("buttonContainer", sectionContent.position)}>
            {sectionContent?.body.map((button: ResolvedMegaMenuCtaButton, index) => (
                <Button
                    className={cx("button")}
                    key={`${button.text}_${index}`}
                    href={button.link}
                    prefetch={false}
                    theme={ButtonPriorityMap[button.priority]}
                    target={button.target}
                >
                    {button.text}
                </Button>
            ))}
        </div>
    );
};

export default HeaderMegaMenuCtaButtons;
